import { render, staticRenderFns } from "./tdxToZyzDetail.vue?vue&type=template&id=255cafe8&scoped=true&"
import script from "./tdxToZyzDetail.vue?vue&type=script&lang=js&"
export * from "./tdxToZyzDetail.vue?vue&type=script&lang=js&"
import style0 from "./tdxToZyzDetail.vue?vue&type=style&index=0&id=255cafe8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255cafe8",
  null
  
)

export default component.exports